import React from 'react';
import PropTypes from 'prop-types';
import ValidationButton from './ValidationButton';
import $ from "jquery";
import "shared/jquery/help_popover";

export default class ModalButtonRow extends React.Component {
  constructor(props) {
    super(props);
    this.helpRef = React.createRef();
  }

  render() {
    const flexTextStyle = { display: "flex", flexDirection: "column", justifyContent: "center", marginRight: "auto" };

    return (
      <div style={{ width: "100%", display: "flex" }}>
        <span ref={this.helpRef} style={flexTextStyle} data-label="move-help-popover">What happens when I move a Promo Number?</span>
        <button className={"btn btn-secondary"} type="button" onClick={this.props.toggle}>Cancel</button>
        <ValidationButton
          className={"btn btn-primary"}
          buttonAction={this.props.submitAction}
          buttonText={"Move"}
          errorMessage={this.props.errorMessage}
          valid={this.props.valid}
        />
      </div>
    );
  }

  componentDidMount() {
    const helpContent = "Invoca will send phone calls to your new destination campaign instead of its current campaign. " +
      "Before you move a promo number, we highly recommend that you pause the campaign you're moving it from to prevent errors.";

    $(this.helpRef.current).helpPopover({
      content: `<p>${helpContent}</p>`,
      placement: "top"
    });
  }
}

ModalButtonRow.propTypes = {
  toggle:       PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  valid:        PropTypes.bool
};
